<fate-input customClass="" [uiId]="uiId" [row]="row" [ngModel]="passthrough" (ngModelChange)="onChange($event)"></fate-input>
<fate-ui class="mat-select-panel" [uiId]="uiId" [buttons]="buttons" [ngClass]="{'visible': uiVisible}"></fate-ui>
